// Copyright (c) 2019 Deere & Company

import './warning-alert-bar.scss';
import { AlertBarBase } from './alert-bar-base';
import PropTypes from 'prop-types';
import React from 'react';

export const WarningAlertBar = props => (
    <div className="warning-alert-bar">
        <AlertBarBase
            alertTitle={props.alertTitle}
            canDismiss={props.canDismiss}
            dismissHandler={props.dismissHandler}
            iconClass="icon-alert-warning"
            timeoutLength={props.timeoutLength}
            willAutoDismiss={props.willAutoDismiss}
        >
            {props.children}
        </AlertBarBase>
    </div>
);

WarningAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    canDismiss: PropTypes.bool,
    children: PropTypes.any.isRequired,
    dismissHandler: PropTypes.func.isRequired,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool,
};

WarningAlertBar.defaultProps = {
    canDismiss: true,
    willAutoDismiss: false,
};
